<template>
	<section>
		<filtros :filter_data="filter_data" @filtrar="filtrar" />

		<table class="table table-striped table-sm">
    		<thead align="center">
    			<th @click="orderBy('ID')"        >ID      <font-awesome-icon v-if="direction.by == 'ID'"        :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('NAME')"      >NOME  <font-awesome-icon v-if="direction.by == 'NAME'"      :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('EXTENSION')" >RAMAL   <font-awesome-icon v-if="direction.by == 'EXTENSION'" :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('PARENT_ID')" >UNIDADE <font-awesome-icon v-if="direction.by == 'PARENT_ID'" :icon="order_icon" size="xs" /></th>
    			<th></th>
    		</thead>

			<transition mode="out-in" name="leftIn">
	    		<tbody v-if="setores" align="center">
	    			<tr v-for="(setor, index) in setores.result.data" :key="index">
						<td>{{ setor.ID }}</td>
						<td>{{ setor.NAME }}</td>
						<td>{{ setor.EXTENSION }}</td>
						<td>{{ get_unidade_name(setor.PARENT_ID) }}</td>
						<td><font-awesome-icon icon="eye" class="info pointer" @click="view(setor)" /></td>
					</tr>

	    		</tbody>
	    		<div v-else><Loading/></div>
	    	</transition>
    	</table>

    	<controls  :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
    	<viewSetor :setor="modal_data"  :action="action"      @alert="show_alert" />
	</section>
</template>

<script>
	import api       from "@/mixins/api.js"
	import replace   from "@/mixins/replace.js"
	import filtros   from "@/components/Tools/Filtro.vue"
	import controls  from "@/components/Tools/Table_Control.vue"
	import viewSetor from "@/components/Modal/Cadastro/Setor.vue"

	export default {
		name: "Setores",
		props: ["table", "method"],
		mixins: [api],
		components: { controls, filtros, viewSetor },

		data() { return {
			setores: null,
			constrol_data: {},
			modal_data: {},
			action: "",
			unidades: { status:null, result:null },

			direction: { order: "asc", by: "ID" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{ name: "ID",        label: "ID",      type: "text",   data_get: ""},
				{ name: "NAME",      label: "Nome",    type: "text",   data_get: ""},
				{ name: "EXTENSION", label: "Ramal",   type: "text",   data_get: ""},
				{ name: "PARENT_ID", label: "Unidade", type: "select", data_get: "Unidade"},
			]
		}},

		created() {
			this.$emit('update:pdf', true)
			this.$emit('update:pdf_title', 'setores')
			this.$emit('update:pdf_external', true)
			this.$emit('update:pdf_datatable', 'Setor')
			this.$emit('update:pdf_header', ["ID", "NOME", "RAMAL", "UNIDADE"] )
			this.$emit('update:pdf_body', ["ID", "NAME", "EXTENSION", "unidade"] )
			this.get_unidades()
			this.get_data()
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			},

			view_nome(){ return this.$store.state.config_view_menu },
		},

		methods: {
			async get_unidades() {
				this.unidades = await this.GET("Unidade")
			},

			get_unidade_name(payload) {
				if(this.unidades){
					for (var i = 0; i <= this.unidades.result.length -1; i++) {
						if ( this.unidades.result[i].id == payload){
							return this.unidades.result[i].nome
						}
					}
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload

				this.get_data()
			},

			filtrar(payload) {
				this.string_filter = payload
				this.$emit('update:pdf_string_filter', payload)
				this.get_data()
			},

			is_super_adm() {
				if(this.$store.state.user.type !== 3){
					return "&PARENT_ID="+this.$store.state.user.unidade_id
				}else {
					return ""
				}
				
			},

			async get_data() {
				this.setores = null
				this.setores = await this.GET("Setor", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`)

				this.constrol_data = {
					current_page: this.setores.result.current_page,
					last_page:    this.setores.result.last_page,
					per_page:     this.setores.result.per_page,
					total:        this.setores.result.total,
				}
			},

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			view(payload) { 
				this.modal_data = payload
				this.action = "view"
				$("#modal-cadastro-setor").modal()
			},

			add() { 
				this.modal_data = {}
				this.action = "add"
				$("#modal-cadastro-setor").modal()
			},

			show_alert(payload) {
				$("#modal-cadastro-setor").modal('hide')
				this.get_data()

				this.$emit('alert', payload)
			},

			pdf_data() {
				const header = ["ID", "SETOR", "RAMAL", "UNIDADE"]
				const body   = []
				const data   = this.setores.result.data

				data.forEach( index => {
					const row = [
						index.ID,
						index.NAME,
						index.EXTENSION,
						this.get_unidade_name(index.PARENT_ID)
					]

					body.push(row)
				})
				
				return {type: "setores", user: this.$store.state.user.name, header, body}
			},
		}
	}
</script>

<style>
	
</style>